<template>
  <div class="view-container">
    <sidebar />
    <div class="app-container">
      <main-header />
      <div class="content">
        <div class="container">
          <div class="row">
            <div class="col-12 content-inner">
              <company />
            </div>
          </div>
        </div>
        <loading-status />
      </div>
    </div>
  </div>
</template>
<script>
import { defineAsyncComponent } from "vue"

export default {
  components: {
    Company: defineAsyncComponent(() => import("../components/company/Company"))
  }
}
</script>
